import {
    displayShortDateOrNA,
    displayPercentOrNaTruthyZero
} from '../../utils/Format/Format';
import { tipsFunds } from '../../utils/fund-info';

let standardYield30DayStandard;
let standardUnsubsidizedThirtyDaySECYield;
export const theCompareTickerFunc = (
    yield30DayStandard,
    unsubsidizedThirtyDaySECYield
) => {
    standardYield30DayStandard = yield30DayStandard * 1.25;
    standardUnsubsidizedThirtyDaySECYield =
        unsubsidizedThirtyDaySECYield * 1.25;
};
export const defaultDisclosure = (ticker) => tipsFunds.includes(ticker);

export const displayDisclosure = (fundYield, unsubsidizedFundYield, ticker) => {
    const fy =
        fundYield >= standardYield30DayStandard && tipsFunds.includes(ticker);

    const ufy =
        unsubsidizedFundYield >= standardUnsubsidizedThirtyDaySECYield &&
        tipsFunds.includes(ticker);
    return !fy ? ufy : fy;
};
export const displayIcon = (ticker) => tipsFunds.includes(ticker);

export const yieldPerformanceUtil = (/* isMoneyMarket, */ ticker, isFI) => (
    gqlResult
) => {
    if (!gqlResult) return null;

    let asOfDate;
    // let title;
    // let returnData;
    // let yield30Day;
    // let unsubsidizedThirtyDay;

    const {
        quarterlyAverageAnnualTotalReturns,
        averageAnnualTotalReturns = {}
    } = gqlResult.fund;

    const quarterlyData =
        quarterlyAverageAnnualTotalReturns ||
        averageAnnualTotalReturns.quarterly;

    const { asOfDate: quarterlyDate } = quarterlyData || {};

    // if (isMoneyMarket) {
    //     const {
    //         sevenDayYieldSimple,
    //         sevenDayYieldSimpleAsOfDate,
    //         unsubsidizedSevenDayYieldSimple
    //     } = gqlResult.fund;
    //
    //     asOfDate = sevenDayYieldSimpleAsOfDate;
    //     title = `7-Day SEC Yield`;
    //     returnData = [
    //         {
    //             label: `w/Waiver`,
    //             values: [
    //                 { val: displayPercentOrNaTruthyZero(sevenDayYieldSimple) }
    //             ]
    //         },
    //         {
    //             label: `w/o Waiver`,
    //             values: [
    //                 {
    //                     val: displayPercentOrNaTruthyZero(
    //                         unsubsidizedSevenDayYieldSimple
    //                     )
    //                 }
    //             ]
    //         }
    //     ];
    // } else {
    const {
        fund: {
            thirtyDayAnnualizedDividendYieldAsOfDate: annualDividendAsOfDate,
            thirtyDayAnnualizedDividendYield,
            yield30DayStandardEffectiveDate: yieldThirtyDatStandardAsOfDate,
            yield30DayStandard,
            thirtyDaySECDividend,
            unsubsidizedThirtyDaySECYieldAsOfDate: secYieldAsOfDate,
            unsubsidizedThirtyDaySECYield,
            thirtyDaySECDividendAsOfDate,
            portfolioCharacteristics
        }
    } = gqlResult;
    const {
        asOfDate: portCharacteristicsAsOfDate,
        fundPortfolioCharacteristic
    } =
        portfolioCharacteristics || {};
    const { yieldToWorst, yieldToMaturity, currentYield } =
        fundPortfolioCharacteristic || {};
    const yield30Day = yield30DayStandard;
    const unsubsidizedThirtyDay = unsubsidizedThirtyDaySECYield;
    const title = `Yield Performance`;

    const returnDataReg = [
        {
            label: `Annualized Dividend as of (${displayShortDateOrNA(
                annualDividendAsOfDate
            )})`,
            values: [
                {
                    /*
                        * @ref: US101651
                        * @note: should only show ann. dividend if
                        * sec stand w/waiver OR w/o waiver are defined
                        */
                    val1: displayPercentOrNaTruthyZero(
                        (yield30DayStandard || unsubsidizedThirtyDaySECYield) &&
                            thirtyDayAnnualizedDividendYield
                    )
                }
            ],
            id: 'annualized-dividend-row'
        },
        {
            label: `SEC Standardized w/Waiver as of (${displayShortDateOrNA(
                yieldThirtyDatStandardAsOfDate
            )})`,
            values: [
                { val1: displayPercentOrNaTruthyZero(yield30DayStandard) }
            ],
            id: 'sec-with-waiver-row',
            yieldSup: displayIcon(ticker)
        },
        {
            label: `SEC Standardized w/o Waiver as of (${displayShortDateOrNA(
                secYieldAsOfDate
            )})`,
            values: [
                {
                    val1: displayPercentOrNaTruthyZero(
                        unsubsidizedThirtyDaySECYield
                    )
                }
            ],
            id: 'sec-without-waiver-row',
            yieldSup: displayIcon(ticker)
        }
    ];

    const returnDataFI = [
        {
            label: `SEC Standardized w/Waiver as of (${displayShortDateOrNA(
                thirtyDaySECDividendAsOfDate
            )})`,
            values: [
                { val1: displayPercentOrNaTruthyZero(thirtyDaySECDividend) }
            ],
            id: 'sec-with-waiver-row'
        },
        {
            label: `SEC Standardized w/o Waiver as of (${displayShortDateOrNA(
                secYieldAsOfDate
            )})`,
            values: [
                {
                    val1: displayPercentOrNaTruthyZero(
                        unsubsidizedThirtyDaySECYield
                    )
                }
            ],
            id: 'sec-without-waiver-row'
        },
        {
            label: `Current Yield as of (${displayShortDateOrNA(
                portCharacteristicsAsOfDate
            )})`,
            values: [{ val1: displayPercentOrNaTruthyZero(currentYield) }],
            id: 'current-yield-row',
            tipContent:
                'Weighted average coupon on securities held in the portfolio as a percentage of the weighted average price.'
        },
        {
            label: `Yield to Maturity as of (${displayShortDateOrNA(
                portCharacteristicsAsOfDate
            )})`,
            values: [{ val1: displayPercentOrNaTruthyZero(yieldToMaturity) }],
            id: 'yield-to-maturity-row',
            tipContent:
                'Weighted average Yield to Maturity (YTM) on the securities held in the portfolio. YTM is the total return anticipated on a bond held to maturity assuming all the securities are held to maturity.'
        },
        {
            label: `Yield to Worst as of (${displayShortDateOrNA(
                portCharacteristicsAsOfDate
            )})`,
            values: [{ val1: displayPercentOrNaTruthyZero(yieldToWorst) }],
            id: 'yield-to-worst-row',
            tipContent:
                'Weighted average Yield to Worst (YTW) on the securities held in the portfolio. YTW is a measure of the lowest possible yield on a bond whose contract includes provisions that would allow the issuer to redeem the securities before they mature.'
        }
    ];

    const returnData = isFI ? returnDataFI : returnDataReg;
    // }

    const headers = [
        `${title}`,
        asOfDate ? `As of ${displayShortDateOrNA(asOfDate)}` : ''
    ];

    return {
        data: returnData,
        headers,
        yield30Day,
        unsubsidizedThirtyDay,
        quarterlyDate
    };
};
